module.exports = {
    Cart:"/cart",
    ProductList:"/",
    CardDetails:"/carddetails",
    SuccessTransact:"/successtransact",
    Product:"/products/:id"
   }